// set of status codes where we don't attempt reconnecting to Twitter
exports.STATUS_CODES_TO_ABORT_ON = [ 400, 401, 403, 404, 406, 410, 413, 422 ];



//////////////////
// WEBPACK FOOTER
// ./node_modules/twit/lib/settings.js
// module id = 261
// module chunks = 0